import PopulationManagement from './PopulationManagement'
export default PopulationManagement
